/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Pending_WebInputs */

const en_fc_online_pending_web = /** @type {(inputs: Fc_Online_Pending_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the web build`)
};

/**
* | output |
* | --- |
* | "Download the web build" |
*
* @param {Fc_Online_Pending_WebInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_pending_web = /** @type {((inputs?: Fc_Online_Pending_WebInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Pending_WebInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_pending_web(inputs)
});
export { fc_online_pending_web as "fc.online.pending.web" }